export const sourceFileIdName = 'sourceFileId';
export const sourceFilesField = 'sourceFiles';
